var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoRede01(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2544",
    transform: "translate(6.055)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2543"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1407",
    d: "M14.7,7.6c1.7-1.5,1.8-4.1,0.3-5.8s-4.1-1.8-5.8-0.3S7.4,5.7,8.9,7.3C9,7.4,9.1,7.5,9.2,7.6 C6.7,8.1,5,10.3,5,12.8v2.3c0,0.3,0.3,0.6,0.6,0.6h12.8c0.3,0,0.6-0.3,0.6-0.6v-2.3C18.9,10.3,17.1,8.1,14.7,7.6z M9,4.6 c0-1.6,1.3-2.9,2.9-2.9c1.6,0,2.9,1.3,2.9,2.9c0,1.6-1.3,2.9-2.9,2.9C10.3,7.5,9,6.2,9,4.6L9,4.6z M17.8,14.5H6.1v-1.7 c0-2.3,1.8-4.1,4.1-4.1h3.5c2.2,0,4.1,1.8,4.1,4.1V14.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2546",
    transform: "translate(0 11.436)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2545"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1408",
    d: "M10.3,16c1.7-1.5,1.8-4.1,0.3-5.8S6.4,8.4,4.8,9.9C3.1,11.5,3,14,4.5,15.7c0.1,0.1,0.2,0.2,0.3,0.3 c-2.5,0.5-4.2,2.6-4.2,5.1v2.3c0,0.3,0.3,0.6,0.6,0.6h12.8c0.3,0,0.6-0.3,0.6-0.6v-2.3C14.5,18.6,12.7,16.5,10.3,16z M4.6,13 c0-1.6,1.3-2.9,2.9-2.9c1.6,0,2.9,1.3,2.9,2.9c0,1.6-1.3,2.9-2.9,2.9C5.9,15.9,4.6,14.6,4.6,13L4.6,13z M13.3,22.9H1.7v-1.7 c0-2.3,1.8-4.1,4.1-4.1h3.5c2.3,0,4.1,1.8,4.1,4.1V22.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2548",
    transform: "translate(12.109 11.436)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2547"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1409",
    d: "M19.1,16c1.7-1.5,1.8-4.1,0.3-5.8c-1.5-1.7-4.1-1.8-5.8-0.3s-1.8,4.1-0.3,5.8c0.1,0.1,0.2,0.2,0.3,0.3 c-2.5,0.5-4.2,2.6-4.2,5.1v2.3c0,0.3,0.3,0.6,0.6,0.6h12.8c0.3,0,0.6-0.3,0.6-0.6v-2.3C23.4,18.6,21.6,16.5,19.1,16z M13.5,13 c0-1.6,1.3-2.9,2.9-2.9c1.6,0,2.9,1.3,2.9,2.9c0,1.6-1.3,2.9-2.9,2.9C14.8,15.9,13.5,14.6,13.5,13L13.5,13z M22.2,22.9H10.5v-1.7 c0-2.3,1.8-4.1,4.1-4.1h3.5c2.3,0,4.1,1.8,4.1,4.1L22.2,22.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2550",
    transform: "translate(1.352 10.752)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2549"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1410",
    d: "M2.7,8.4l-1.2,0c0,0.4,0,0.8,0.1,1.2l1.2-0.1C2.7,9.1,2.7,8.8,2.7,8.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2552",
    transform: "translate(1.352 9.383)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2551"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1411",
    d: "M1.6,7.4c0,0.4-0.1,0.8-0.1,1.2l1.2,0c0-0.4,0-0.7,0.1-1.1L1.6,7.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2554",
    transform: "translate(4.25 3.471)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2553"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1412",
    d: "M4.6,3.1C4.3,3.3,3.9,3.6,3.6,3.8l0.8,0.9C4.7,4.5,5,4.2,5.3,4L4.6,3.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2556",
    transform: "translate(1.902 6.703)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2555"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1413",
    d: "M2.4,5.4C2.2,5.8,2.1,6.2,1.9,6.6L3,7c0.1-0.3,0.3-0.7,0.4-1L2.4,5.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2558",
    transform: "translate(1.518 8.014)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2557"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1414",
    d: "M1.9,6.4C1.8,6.8,1.7,7.2,1.6,7.6l1.1,0.2C2.9,7.4,3,7.1,3.1,6.7L1.9,6.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2560",
    transform: "translate(3.289 4.406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2559"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1415",
    d: "M3.7,3.8C3.5,4.1,3.2,4.4,2.9,4.7l0.9,0.7c0.2-0.3,0.5-0.6,0.7-0.8L3.7,3.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2562",
    transform: "translate(5.361 2.715)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2561"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1416",
    d: "M5.5,2.5c-0.3,0.2-0.7,0.4-1,0.6l0.6,1c0.3-0.2,0.6-0.4,1-0.6L5.5,2.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2564",
    transform: "translate(2.498 5.49)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2563"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1417",
    d: "M3,4.6c-0.2,0.3-0.4,0.7-0.6,1l1,0.6C3.6,5.8,3.8,5.5,4,5.2L3,4.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2566",
    transform: "translate(8.363 18.342)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2565"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1418",
    d: "M6.9,13.9l-0.2,1.1c0.4,0.1,0.8,0.1,1.2,0.2L8,14.1C7.6,14.1,7.2,14,6.9,13.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2568",
    transform: "translate(11.068 18.338)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2567"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1419",
    d: "M9.7,13.9C9.4,14,9,14.1,8.6,14.1l0.1,1.2c0.4,0,0.8-0.1,1.2-0.2L9.7,13.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2570",
    transform: "translate(9.752 18.492)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2569"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1420",
    d: "M8.8,14.1c-0.4,0-0.7,0-1.1,0l0,1.2c0.2,0,0.4,0,0.6,0c0.2,0,0.4,0,0.6,0L8.8,14.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2572",
    transform: "translate(15.482 3.92)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2571"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1421",
    d: "M12.6,3.4l-0.8,0.9c0.3,0.2,0.5,0.5,0.8,0.8l0.8-0.8C13.2,4,12.9,3.7,12.6,3.4z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2574",
    transform: "translate(16.371 4.934)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2573"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1422",
    d: "M13.4,4.1l-0.9,0.7c0.2,0.3,0.5,0.6,0.7,0.9l1-0.7C13.9,4.8,13.7,4.5,13.4,4.1z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2576",
    transform: "translate(18.156 10.082)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2575"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1423",
    d: "M15,7.9l-1.2,0c0,0.2,0,0.4,0,0.6c0,0.2,0,0.4,0,0.6l1.2,0c0-0.2,0-0.4,0-0.6C15,8.3,15,8.1,15,7.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2578",
    transform: "translate(17.102 6.086)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2577"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1424",
    d: "M14,5l-1,0.6c0.2,0.3,0.4,0.7,0.5,1l1.1-0.5C14.4,5.7,14.2,5.3,14,5z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2580",
    transform: "translate(17.65 7.35)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2579"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1425",
    d: "M14.5,5.9l-1.1,0.4c0.1,0.3,0.2,0.7,0.3,1.1l1.1-0.3C14.8,6.7,14.7,6.3,14.5,5.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2582",
    transform: "translate(18.004 8.693)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2581"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1426",
    d: "M14.8,6.9l-1.1,0.2c0.1,0.4,0.1,0.7,0.2,1.1L15,8.1C15,7.7,14.9,7.3,14.8,6.9z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2584",
    transform: "translate(14.459 3.07)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2583"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1427",
    d: "M11.7,2.8l-0.6,1C11.4,4,11.7,4.2,12,4.4l0.7-0.9C12.4,3.2,12.1,3,11.7,2.8z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2586",
    transform: "translate(13.32 2.41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2585"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1428",
    d: "M10.7,2.3l-0.5,1.1c0.3,0.1,0.7,0.3,1,0.5l0.6-1C11.5,2.6,11.1,2.5,10.7,2.3z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoRede01);
export default __webpack_public_path__ + "static/media/ico-rede-01.ea64914232be397711a4afb1aefbb97d.svg";
export { ForwardRef as ReactComponent };